/**
 * 결재 AI 어시스턴트(beta) 노출 대상 (PORTAL-15493).
 *
 * 베타 기간에는 IT담당 소속만 본다. 조직 코드(`organizationCode`)는 계층형 접두어 구조라
 * FF13(디지털본부) > FF137(IT담당) > FF13740 > FF1374010(Web Platform팀) 처럼 상위 코드가 앞에 온다.
 * 그래서 `FF137` 로 시작하면 IT담당 산하 어느 팀이든 해당한다. 운영 오픈 때 목록을 비우면 전원에게 보인다.
 */
export const APPROVAL_AI_ASSISTANT_ALLOWED_ORG_CODE_PREFIXES: readonly string[] =
  ['FF137'];

type OrgInfo = {
  organizationCode?: string | null;
};

export const canUseApprovalAiAssistant = (
  myInfo: OrgInfo | null | undefined,
  allowedPrefixes: readonly string[] = APPROVAL_AI_ASSISTANT_ALLOWED_ORG_CODE_PREFIXES,
): boolean => {
  if (!myInfo) return false;
  if (allowedPrefixes.length === 0) return true;
  const code = (myInfo.organizationCode ?? '').trim().toUpperCase();
  if (!code) return false;
  return allowedPrefixes.some((prefix) =>
    code.startsWith(prefix.toUpperCase()),
  );
};
